import { io } from "socket.io-client";

const socketURL = process.env.REACT_APP_CIP_API_URL;

const socket = io(socketURL, {
  transports: ["websocket"],
});

export default socket;
